import { ListItem, ListItemAvatar, ListItemIcon, ListItemText } from '@mui/material';
import { Avatar, Checkbox } from '~/UIKit';
import React from 'react';
import { getInitials } from '../../../../Helpers/String.helper';
import { BORDER_COLOR, PRIMARY_BLUE } from '../../../../Constants/Colors.constants';
import { makeStyles } from '~/UIKit/Style';

export interface BookingDialogListItemComponentProps {
  index: number;
  imageId: string;
  firstname: string | undefined;
  lastname: string | undefined;
  id: string | number | undefined;
  handleSelect: () => void;
  hasBeenSelected: (id: string | number) => boolean;
}

const useStyles = makeStyles({
  root: {
    borderBottom: `1px solid ${BORDER_COLOR}`,
    height: 60,
    '& .MuiTouchRipple-child': {
      backgroundColor: PRIMARY_BLUE,
    },
  },
  checkBoxRoot: {
    minWidth: 46,
  },
  customerName: {
    '& .MuiListItemText-primary': {
      fontWeight: 'bold',
      lineHeight: '20px',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    },
  },
  customerAvatarRoot: {
    minWidth: 45,
  },
  customerAvatar: {
    width: 30,
    height: 30,
    fontSize: 12,
    fontWeight: 'bold',
  },
});

export const BookingDialogListItem = ({
  index,
  id = -1,
  imageId,
  firstname = '',
  lastname = '',
  handleSelect,
  hasBeenSelected,
}: BookingDialogListItemComponentProps) => {
  const { classes } = useStyles();

  const handleClickEvent = () => {
    handleSelect();
  };
  const initials = getInitials(firstname, lastname);
  return (
    <ListItem
      button
      className={classes.root}
      data-testid="BookingDialogListItem"
      key={index}
      onClick={handleClickEvent}
    >
      <ListItemIcon className={classes.checkBoxRoot}>
        <Checkbox
          checked={hasBeenSelected(id)}
          color="primary"
          disableRipple
          edge="start"
          inputProps={{ 'aria-labelledby': `${id}` }}
        />
      </ListItemIcon>
      <ListItemAvatar className={classes.customerAvatarRoot}>
        <Avatar alt={initials} className={classes.customerAvatar} src={imageId}>
          {initials}
        </Avatar>
      </ListItemAvatar>
      <ListItemText
        className={classes.customerName}
        id={`${id}`}
        primary={`${firstname} ${lastname}`}
      />
    </ListItem>
  );
};
